export const KUNKUNUUID = "8ede2d13-9908-44f7-92d2-a639611384c6";
export const SEARVICEUUID = '0000180a-0000-1000-8000-00805f9b34fb'
export const SENSORDATACHARACTERISTICUUID = "e91e324c-335e-4f18-93db-e810a80da24d";
export const PAIRINGCHARACTERISTICUUID = "1779ab6a-6e14-4171-af3d-5b588e0e4343";
export const HEATERCHARACTERISTICUUID = "801f1554-886b-412c-b2b7-773078f95fdd";
export const ENVIRONMENTALSENSINGUUID = '0000181a-0000-1000-8000-00805f9b34fb';
export const TEMPERTUREUUID = '00002a6e-0000-1000-8000-00805f9b34fb';
export const HUMIDITYUUID = '00002a6f-0000-1000-8000-00805f9b34fb';
